import React from 'react';
import './ElementsHighlight.css';
import zIndex from '@material-ui/core/styles/zIndex';

function ElementsHighlight({ data, colorCode, setOpenHighlightModal, handleClickedArea, showSquareHighlight, handleChangeClickArea, handleChangeNeighborArea }) {

    const labelStyle = {
        position: 'absolute',
        right: 0,
        top: -20,
        backgroundColor: '#000',
        color: 'white',
        padding: '0px 5px',
        fontSize: '11px',
        display: "none",
    }

    const getSquareStyle = (x, y, w, h) => {
        return {
            position: 'absolute',
            left: x,
            top: y,
            width: w,
            height: h,
            boxSizing: 'border-box'
        }
    }

    return (
        data.map(item => {
            return (
                <div className="highlightArea"
                    onClick={(e) => !showSquareHighlight
                        ? handleClickedArea(e, item.coordinate[0], item.coordinate[1])
                        : handleChangeClickArea(e, item.coordinate[0], item.coordinate[1], item.coordinate[2], item.coordinate[3])}
                    onContextMenu={(e) => showSquareHighlight && handleChangeNeighborArea(e, item.coordinate[0], item.coordinate[1], item.coordinate[2], item.coordinate[3])}
                    style={getSquareStyle(item.coordinate[0], item.coordinate[1], item.coordinate[2], item.coordinate[3])}>
                    <div className="highlightAreaBg" style={{ backgroundColor: colorCode, border: '2px solid' + colorCode }}></div>
                    <span style={labelStyle}>{item.label}</span>
                </div >
            )
        })
    );
}

export default ElementsHighlight;